import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';
import { useUserContext } from '../../context/userProvider';
import NavbarButtons from '../Shared/NavbarButtons';
import LogoPurple from '../../assets/images/extension/logo-text-purple.png';
import logoLight from '../../assets/images/extension/logo-text-white.png';

const Topbar = ({ location }) => {
  const { currentUser } = useUserContext();

  return (
    <header
      id="topnav"
      className="defaultscroll sticky"
      style={{ position: currentUser ? 'absolute' : 'fixed' }}
    >
      <Container>
        <div>
          <Link className="logo" to="/">
            <img
              src={LogoPurple}
              height="24"
              alt=""
            />
          </Link>
        </div>
        {/* The landing page's mobile hero leads with the app download, so drop the competing Sign Up button there. */}
        <NavbarButtons currentUser={currentUser} hideSignUpOnMobile={location.pathname === '/'} />
      </Container>
    </header>
  );
};
export default withRouter(Topbar);
